import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './rootReducer';

// Re-export RootState from rootReducer to maintain backwards compatibility
export type { RootState } from './rootReducer';

export const store = configureStore({
    reducer: rootReducer
});

export type AppDispatch = typeof store.dispatch;
